import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

export const DashboardTemplatesPromotionTooltipContent = styled.div`
    width: 200px;
    box-sizing: border-box;
`;

export const DashboardTemplatesPromotionTooltipTitle = styled.div`
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 3px;
    color: ${colorsPalettes.carbon[0]};
`;

export const DashboardTemplatesPromotionTooltipText = styled.div`
    font-weight: 400;
    font-size: 12px;
    line-height: 17px;
    color: ${colorsPalettes.carbon[0]};
`;
